import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminRefundSettingsDataSourceService } from '../../services/admin-refund-settings-data-source.service';
import { AdminRefundSettingsFormData } from '../../models/admin-refund-settings-form-data';
import { AdminRefundSettingsFormComponent } from '../admin-refund-settings-form/admin-refund-settings-form.component';

@Component({
  selector: 'app-admin-refund-settings',
  imports: [
    CommonModule,
    AlertsComponent,
    SpinnerFilledComponent,
    AdminRefundSettingsFormComponent,
  ],
  templateUrl: './admin-refund-settings.component.html',
  styleUrl: './admin-refund-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminRefundSettingsComponent implements OnInit {
  private readonly refundSettingsDataSource = inject(
    AdminRefundSettingsDataSourceService,
  );
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  protected data$!: Observable<AdminRefundSettingsFormData>;

  public ngOnInit(): void {
    this.data$ = this.refundSettingsDataSource.fetchSettingsFormData();
  }

  public handleSubmitClick(data: AdminRefundSettingsFormData): void {
    this.refundSettingsDataSource
      .updateSettingsByFormData(data)
      .pipe(once())
      .subscribe({
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
